const conversationIndexNeedsBootstrap = status => {
  if (!status) return false
  if (status.phase === 'failed' && ['error', 'failed'].includes(status.state)) return true
  if (!['not-started', 'stale'].includes(status.state)) return false
  return Math.max(0, Number(status.message_count) || 0) > 0
}

module.exports = {
  conversationIndexNeedsBootstrap
}
